export default __webpack_public_path__ + "static/blob3-adf72faf63ff41a0c2b505265e746c7f.svg";